import { clx } from '../../lib/utils';

export const BackButton = ({ className }: { className?: string }) => {
  return (
    <button
      onClick={() => window.history.back()}
      className={clx('flex flex-col items-center gap-2 text-sm', className)}
    >
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="2"
          y1="6"
          x2="14"
          y2="6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="2"
          y1="6"
          x2="6"
          y2="2"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="2"
          y1="6"
          x2="6"
          y2="10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};
